<template>
<div class="text-xs-center">
    <v-dialog v-model="beforeLoad" hide-overlay persistent width="300">
        <v-card color="rgb(166, 195, 7)" dark>
            <v-card-text>
                {{$t('message.stand_by')}}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    name: 'loader',
    props: {
        beforeLoad: { type: Boolean, default: false },
    },
    data() {
        return {
        }
    },

    // watch: {
    //   dialog (val) {
    //     if (!val) return
    //
    //     setTimeout(() => (this.dialog = false), 4000)
    //   }
    // }
}
</script>
